/* Science evidence: on phones the grid starts with 3 cards (the rest carry .is-mobile-hidden).
   "View more" reveals the next 3 per tap and hides itself when every card is showing. */
(function () {
  function init(root) {
    root.querySelectorAll('[data-se-view-more]').forEach(function (button) {
      if (button.__seBound) return;
      button.__seBound = true;
      var section = button.closest('.m-science-evidence');
      var grid = section && section.querySelector('[data-se-grid]');
      if (!grid) return;
      var step = parseInt(grid.getAttribute('data-se-step'), 10) || 3;

      button.addEventListener('click', function () {
        var hidden = grid.querySelectorAll('.is-mobile-hidden');
        for (var i = 0; i < hidden.length && i < step; i++) hidden[i].classList.remove('is-mobile-hidden');
        if (!grid.querySelector('.is-mobile-hidden')) button.closest('.m-science-evidence__more-cta').hidden = true;
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
